import React, { useMemo } from 'react'

import { UseFormWatch } from 'react-hook-form'
import { UseFormSetValue } from 'react-hook-form/dist/types/form'

import { Tooltip, Txt } from 'src/components/atoms'
import { SelectExternalUsersInput, TableSortType } from 'src/components/molecules'
import { ExternalAssignUserEditTableHead } from 'src/components/molecules/projects/ExternalAssignUserEditTableHead'
import { ExternalAssignUserSortItemType } from 'src/components/molecules/projects/ExternalAssignUserTableHead'

import { useGetExternalUsers } from 'src/hooks'
import { ExternalUserEntity, ProjectAssignUser, UpsertProjectFormEntity } from 'src/types'

type Props = {
  watch: UseFormWatch<UpsertProjectFormEntity>
  setValue: UseFormSetValue<UpsertProjectFormEntity>
  sortItem: ExternalAssignUserSortItemType
  sortType: TableSortType
  onSelectItem: (newItem: ExternalAssignUserSortItemType) => void
  onSelectSortType: (newType: TableSortType) => void
  className?: string
}

export function ExternalAssignUserEditTableTop({
  watch,
  setValue,
  sortItem,
  sortType,
  onSelectItem,
  onSelectSortType,
  className,
}: Props) {
  const { loading, externalUsers } = useGetExternalUsers()

  const excludedExternalUsers = useMemo(() => {
    if (loading) {
      return
    }
    return externalUsers.filter(user =>
      watch('externalEditors').some(assignedUser => assignedUser.id === user.id)
    )
  }, [externalUsers, loading, watch])

  const handleOnSelectExternalUser = (user: ExternalUserEntity) => {
    const assignedUser: ProjectAssignUser = { id: user.id, email: user.email, name: user.name }
    setValue('externalEditors', [...watch('externalEditors'), assignedUser])
  }

  const handleOnBatchSelect = (users: ExternalUserEntity[]) => {
    const selectedExternalUsers = externalUsers.filter(externalUser =>
      users.some(selectedUser => selectedUser.id === externalUser.id)
    )
    setValue('externalEditors', [...watch('externalEditors'), ...selectedExternalUsers])
  }

  return (
    <div className={className}>
      <div className="tw-bg-surface-secondary tw-px-s0 tw-py-s-2 tw-rounded-t-[8px] tw-overflow-hidden">
        <Tooltip
          placement="top"
          content={
            <Txt sizeType="s">
              「ユーザー」画面で追加済のユーザー名で検索して「決
              <br />
              定」で指定メールアドレスへ、このROOV compassプロ
              <br />
              ジェクトへアサインを知らせるメールが送信されます。
            </Txt>
          }
        >
          <Txt sizeType="s" className="tw-font-bold">
            社外ユーザー
          </Txt>
        </Tooltip>
      </div>
      <SelectExternalUsersInput
        excludedExternalUsers={excludedExternalUsers}
        onSelectExternalUser={handleOnSelectExternalUser}
        onBatchSelect={handleOnBatchSelect}
      />
      <ExternalAssignUserEditTableHead
        sortItem={sortItem}
        sortType={sortType}
        onSelectItem={onSelectItem}
        onSelectSortType={onSelectSortType}
        className="tw-border-b tw-border-b-border-secondary"
      />
    </div>
  )
}
